import { c as _c } from "react/compiler-runtime";
import { ErrorDetailMessage } from "@context-providers/error-boundary/error-detail-message";
import { Button, WarningIcon, Text } from "@flat-ui";
import { Box, Grid, Stack } from "@mui-wrapper";
import { removeOne } from "@store/errors/errors-slice";
import { useAppDispatch } from "@store/store-helper";
import { HEADER_HEIGHT } from "@utils/ui-utils";
/**
 * Displays an error message with the ability to go to home page or reload the page
 */
export function ErrorPage(t0) {
  const $ = _c(29);
  const {
    error,
    onReload,
    onGoHome
  } = t0;
  const dispatch = useAppDispatch();
  let t1;
  if ($[0] !== dispatch || $[1] !== error.id || $[2] !== onReload) {
    t1 = function onReloadHandler() {
      dispatch(removeOne(error.id));
      onReload && onReload();
    };
    $[0] = dispatch;
    $[1] = error.id;
    $[2] = onReload;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const onReloadHandler = t1;
  let t2;
  if ($[4] !== dispatch || $[5] !== error.id || $[6] !== onGoHome) {
    t2 = function onGoHomeHandler() {
      dispatch(removeOne(error.id));
      onGoHome && onGoHome();
    };
    $[4] = dispatch;
    $[5] = error.id;
    $[6] = onGoHome;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const onGoHomeHandler = t2;
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      minHeight: `calc(100vh - ${HEADER_HEIGHT})`,
      width: "100%",
      gap: 2
    };
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      justifyContent: "space-between",
      alignItems: "center"
    };
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <WarningIcon sx={{
      marginRight: "10px"
    }} />;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== error.title) {
    t6 = <Stack direction="row" sx={t4}>{t5}<Text variant="heading20">{error.title}</Text></Stack>;
    $[11] = error.title;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <b>Developer Error Message:</b>;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== error.error) {
    t8 = <Grid><Text variant="bodyL" component="div">{t7}<ErrorDetailMessage error={error.error} /></Text></Grid>;
    $[14] = error.error;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      mr: "40px"
    };
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== onGoHomeHandler) {
    t10 = <Button onClick={onGoHomeHandler} variant="secondary" draggable={false} sx={t9}>Return to Home</Button>;
    $[17] = onGoHomeHandler;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== onReloadHandler) {
    t11 = <Button onClick={onReloadHandler} variant="secondary" draggable={false}>Reload</Button>;
    $[19] = onReloadHandler;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t10 || $[22] !== t11) {
    t12 = <div>{t10}{t11}</div>;
    $[21] = t10;
    $[22] = t11;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== error.id || $[25] !== t12 || $[26] !== t6 || $[27] !== t8) {
    t13 = <Box key={error.id} component="div" data-testid="handled-error-page" sx={t3}>{t6}{t8}{t12}</Box>;
    $[24] = error.id;
    $[25] = t12;
    $[26] = t6;
    $[27] = t8;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  return t13;
}